import './style.scss';

export function hero_block() {
  const block = document.querySelector('.hero_block');
  if (!block) return;


  /* ----------------------------------
   * CONFIG
   * ---------------------------------- */
  const SLIDE_DURATION = 10000;

  const isTouchDevice =
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0;

  /* ----------------------------------
   * DOM
   * ---------------------------------- */
  const images = [...block.querySelectorAll('.hero-image')];
  const texts  = [...block.querySelectorAll('.hero-sub-text')];
  const cards  = [...block.querySelectorAll('.nav-card')];
  const progress = block.querySelector('.progress-bar-fill');
  const heroImages = [...block.querySelectorAll('.hero-images')];

  const TOTAL = images.length;
  if (!TOTAL) return;

  /* ----------------------------------
   * STATE
   * ---------------------------------- */
  const state = {
    index: 0,
    playing: true,
    slideStart: performance.now(),
    tooltipIndex: Array(TOTAL).fill(0),
    tooltipLast: performance.now()
  };

  let rafId = null;

  /* ----------------------------------
   * HELPERS
   * ---------------------------------- */
  const setActive = (list, i) => {
    list.forEach((el, idx) =>
      el.classList.toggle('is-active', idx === i)
    );
  };

 const indexedGroups = [
  texts,
  cards,
  heroImages
];

function renderStatic() {
  indexedGroups.forEach(group =>
    setActive(group, state.index)
  );
}

  function getTooltipDuration() {
    const tips =
      images[state.index]?.querySelectorAll('.image-cursor-layout') || [];
    return tips.length
      ? SLIDE_DURATION / tips.length
      : SLIDE_DURATION;
  }

  /* ----------------------------------
   * PROGRESS
   * ---------------------------------- */
  function renderProgress(now) {
    if (!progress) return;
    const elapsed = now - state.slideStart;
    const pct = Math.min(100, (elapsed / SLIDE_DURATION) * 100);
    progress.style.width = `${pct}%`;
  }

  /* ----------------------------------
   * TOOLTIPS
   * ---------------------------------- */
  function renderTooltips(now) {
    const image = images[state.index];
    if (!image) return;

    const tips = image.querySelectorAll('.image-cursor-layout');
    if (!tips.length) return;

    /* 🚫 Touch devices: NO animation */
    if (isTouchDevice) {
      tips.forEach(t => t.classList.remove('is-active'));
      tips[0].classList.add('is-active');
      return;
    }

    const tooltipDuration = getTooltipDuration();

    if (now - state.tooltipLast < tooltipDuration) return;

    tips.forEach(t => t.classList.remove('is-active'));

    const i = state.tooltipIndex[state.index] % tips.length;
    tips[i].classList.add('is-active');

    state.tooltipIndex[state.index]++;
    state.tooltipLast = now;
  }

  /* ----------------------------------
   * LOOP CONTROL
   * ---------------------------------- */
  function startLoop() {
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(loop);
  }

  function goTo(i) {
    state.index = (i + TOTAL) % TOTAL;
    state.slideStart = performance.now();
    state.tooltipLast = state.slideStart;

    renderStatic();
    startLoop();
  }

  function next() {
    goTo(state.index + 1);
  }

  function loop(now) {
    if (!state.playing) return;

    renderProgress(now);
    renderTooltips(now);

    if (now - state.slideStart >= SLIDE_DURATION) {
      next();
    }

    rafId = requestAnimationFrame(loop);
  }

  /* ----------------------------------
   * INTERSECTION OBSERVER
   * ---------------------------------- */
  const io = new IntersectionObserver(
    ([entry]) => {
      state.playing = entry.isIntersecting;

      if (state.playing) {
        state.slideStart = performance.now();
        state.tooltipLast = state.slideStart;
        startLoop();
      } else {
        cancelAnimationFrame(rafId);
      }
    },
    { threshold: 0.3 }
  );

  io.observe(block);

  /* ----------------------------------
   * NAV CLICK
   * ---------------------------------- */
  cards.forEach((card, i) => {
    card.addEventListener('click', () => goTo(i), { passive: true });
  });

  /* ----------------------------------
   * INIT
   * ---------------------------------- */
  renderStatic();
  startLoop();

  /* ----------------------------------
   * DESTROY
   * ---------------------------------- */
  return () => {
    cancelAnimationFrame(rafId);
    io.disconnect();
  };
}
